import request from "@/api/request";

export function list(params) {
    return request({
        url: '/api/img/list',
        method: 'post',
        params: params
    })
}
